import {
  IssueType,
  ProductModelType,
  TestMachineType,
} from "@/app/types/typeConfig/issueType";
import { ComponentTypeEnum } from "@/app/types/typeConfig/chatQuestion";
import type { LocaleType } from "@/app/locales/cn";
import zhCN from "@/app/locales/cn";
import enUS from "@/app/locales/en";

// 获取语言包
const getLocaleMessages = (locale?: string): LocaleType => {
  const lang =
    locale ||
    (typeof window !== "undefined"
      ? localStorage.getItem("i18nextLng")
      : null) ||
    "zh-CN";
  const normalizedLang = lang.toLowerCase().includes("zh") ? "zh-CN" : "en-US";
  return normalizedLang === "zh-CN" ? zhCN : enUS;
};

export const requireIssueTypeSet = (locale?: string): IssueType => {
  const messages = getLocaleMessages(locale);
  const t = messages.issueType;
  return {
    1: {
      templateName: "",
      value: "",
      children: [],
      templateFlag: "collectOrderInfo",
      type: ComponentTypeEnum.Robot,
    },
    2: {
      templateName: t.missionItems.templateName,
      value: "3,0",
      children: [],
      templateFlag: "uDeskTicket",
      attachment: true,
      attachmentRequired: true,
      attachmentTips: [
        t.missionItems.attachmentTips[0],
        t.missionItems.attachmentTips[1],
        t.missionItems.attachmentTips[2],
      ],
    },
    3: {
      templateName: t.receivedTheWrongItem.templateName,
      value: "3,1",
      children: [],
      templateFlag: "uDeskTicket",
      attachment: true,
      attachmentRequired: true,
      attachmentTips: [
        t.receivedTheWrongItem.attachmentTips[0],
        t.receivedTheWrongItem.attachmentTips[0],
      ],
    },
    4: {
      templateName: t.shippingOrPackaging.templateName,
      value: "8",
      attachment: true,
      attachmentRequired: true,
      attachmentTips: [
        t.shippingOrPackaging.attachmentTips[0],
        t.shippingOrPackaging.attachmentTips[1],
        t.shippingOrPackaging.attachmentTips[2],
      ],
      attachmentTipText: t.shippingOrPackaging.attachmentTipText,
      children: [
        {
          label: t.shippingOrPackaging.children[0],
          value: "8,0",
        },
        {
          label: t.shippingOrPackaging.children[1],
          value: "8,1",
        },
        {
          label: t.shippingOrPackaging.children[2],
          value: "8,2",
        },
        {
          label: t.shippingOrPackaging.children[3],
          value: "8,3",
          children: [],
        },
        {
          label: t.shippingOrPackaging.children[4],
          value: "8,4",
          children: [],
        },
      ],
      templateFlag: "uDeskTicket",
    },
    5: {
      templateName: t.factoryDamage.templateName,
      value: "3,2",
      attachmentTips: [
        t.factoryDamage.attachmentTips[0],
        t.factoryDamage.attachmentTips[1],
        t.factoryDamage.attachmentTips[2],
      ],
      attachment: true,
      attachmentRequired: true,
      children: [],
      templateFlag: "uDeskTicket",
    },
    6: {
      templateName: "Manufacturing issue",
      value: "3,4",
      children: [],
      attachmentTips: [
        t.manufacturingIssue.attachmentTips[0],
        t.manufacturingIssue.attachmentTips[1],
        t.manufacturingIssue.attachmentTips[2],
      ],
      attachment: true,
      attachmentRequired: true,
      templateFlag: "uDeskTicket",
    },
    7: {
      templateName: t.other,
      value: "3,3",
      children: [],
      attachment: true,
      templateFlag: "uDeskTicket",
    },
    8: {
      templateName: t.lostPackage.templateName,
      value: "2,0",
      childLabelTips: t.lostPackage.childLabelTips,
      children: [
        {
          label: t.lostPackage.children[0],
          value: "2,0,0",
        },
        {
          label: t.lostPackage.children[1],
          value: "2,0,1",
        },
        {
          label: t.lostPackage.children[2],
          value: "2,0,2",
        },
        {
          label: t.lostPackage.children[3],
          value: "2,0,3",
        },
      ],
      attachment: true,
      attachmentRequired: false,
      attachmentTips: [t.lostPackage.attachmentTips],
      templateFlag: "uDeskTicket",
    },
    9: {
      templateName: t.noShippingMovementForDays,
      value: "2,9",
      children: [],
      templateFlag: "uDeskTicket",
    },
    10: {
      templateName: t.shippedToTheWrongAddress.templateName,
      value: "2,4",
      children: [
        {
          label: t.shippedToTheWrongAddress.children[0],
          value: "2,4,0",
        },
        {
          label: t.shippedToTheWrongAddress.children[1],
          value: "2,4,1",
        },
        {
          label: t.shippedToTheWrongAddress.children[2],
          value: "2,4,2",
        },
      ],
      templateFlag: "uDeskTicket",
    },
    11: {
      templateName: t.packageWasReturnedToSenderOrCanceled,
      value: "2,5",
      children: [],
      templateFlag: "uDeskTicket",
    },
    12: {
      templateName: t.carrierServiceComplaint,
      value: "2,6",
      children: [],
      templateFlag: "uDeskTicket",
    },
    13: {
      templateName: t.other,
      value: "2,8",
      children: [],
      templateFlag: "uDeskTicket",
    },
  };
};

export const TestMachineOptions = (locale?: string): TestMachineType[] => {
  const messages = getLocaleMessages(locale);
  const t = messages.issueType;
  return [
    {
      label: t.testMachineOptions[0],
      value: "No, I have not tested the printer/AMS.",
    },
    {
      label: t.testMachineOptions[1],
      value: "Yes, it works properly.",
    },
    {
      label: t.testMachineOptions[2],
      value: "Yes, but it malfunctions.",
    },
  ];
};
export const OtherValueSet: Array<string | number> = [
  "8,4",
  "2,4,2",
  "2,0,3",
  "3,3",
  "2,8",
];

export const TestMachineSet: Array<string> = ["8,0", "8,1", "8,2"];
export const ProductModelOptions: Array<ProductModelType> = [
  // {
  //   label: 'X1 Carbon',
  //   value: 1,
  // },
  // {
  //   label: 'P1P',
  //   value: 4,
  // },
  // {
  //   label: 'P1S',
  //   value: 8,
  // },
  // {
  //   label: 'A1',
  //   value: 15,
  // },
  // {
  //   label: 'A1 mini',
  //   value: 10,
  // },
  // {
  //   label: 'AMS',
  //   value: 2,
  // },
  // {
  //   label: 'AMS lite',
  //   value: 11,
  // },
  {
    label: "X1 Series",
    value: 16,
  },
  {
    label: "P1 Series",
    value: 17,
  },
  {
    label: "A1 Series",
    value: 20,
  },
  {
    label: "AMS Series",
    value: 21,
  },
  {
    label: "Accessories",
    value: 3,
  },
  {
    label: "Filaments",
    value: 5,
  },
  {
    label: "Other",
    value: 7,
  },
];
export const NoFoundKnowledgeId = "999";

export const AIAnswerKnowledgeId = "888";
